// extracted by mini-css-extract-plugin
module.exports = {"grid":"invoicesChanges-grid_grid__2TdEX"};